/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ControllingRouteImport } from './routes/controlling'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SucheRouteImport } from './routes/suche'
import { Route as TotesKapitalRouteImport } from './routes/totes-kapital'
import { Route as VerkaufssucheRouteImport } from './routes/verkaufssuche'
import { Route as AdminApiKeysRouteImport } from './routes/admin_.api-keys'
import { Route as AdminArchivRouteImport } from './routes/admin_.archiv'
import { Route as AdminUploadRouteImport } from './routes/admin_.upload'
import { Route as AdminUsersRouteImport } from './routes/admin_.users'
import { Route as ArtikelIdRouteImport } from './routes/artikel.$id'
import { Route as LieferantNameRouteImport } from './routes/lieferant.$name'
import { Route as AdminUsersImportRouteImport } from './routes/admin_.users_.import'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const ControllingRoute = ControllingRouteImport.update({
  id: '/controlling',
  path: '/controlling',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SucheRoute = SucheRouteImport.update({
  id: '/suche',
  path: '/suche',
  getParentRoute: () => rootRouteImport,
} as any)
const TotesKapitalRoute = TotesKapitalRouteImport.update({
  id: '/totes-kapital',
  path: '/totes-kapital',
  getParentRoute: () => rootRouteImport,
} as any)
const VerkaufssucheRoute = VerkaufssucheRouteImport.update({
  id: '/verkaufssuche',
  path: '/verkaufssuche',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminApiKeysRoute = AdminApiKeysRouteImport.update({
  id: '/admin_/api-keys',
  path: '/admin/api-keys',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminArchivRoute = AdminArchivRouteImport.update({
  id: '/admin_/archiv',
  path: '/admin/archiv',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUploadRoute = AdminUploadRouteImport.update({
  id: '/admin_/upload',
  path: '/admin/upload',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin_/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const ArtikelIdRoute = ArtikelIdRouteImport.update({
  id: '/artikel/$id',
  path: '/artikel/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const LieferantNameRoute = LieferantNameRouteImport.update({
  id: '/lieferant/$name',
  path: '/lieferant/$name',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersImportRoute = AdminUsersImportRouteImport.update({
  id: '/admin_/users_/import',
  path: '/admin/users/import',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/controlling': typeof ControllingRoute
  '/login': typeof LoginRoute
  '/suche': typeof SucheRoute
  '/totes-kapital': typeof TotesKapitalRoute
  '/verkaufssuche': typeof VerkaufssucheRoute
  '/admin/api-keys': typeof AdminApiKeysRoute
  '/admin/archiv': typeof AdminArchivRoute
  '/admin/upload': typeof AdminUploadRoute
  '/admin/users': typeof AdminUsersRoute
  '/artikel/$id': typeof ArtikelIdRoute
  '/lieferant/$name': typeof LieferantNameRoute
  '/admin/users/import': typeof AdminUsersImportRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/controlling': typeof ControllingRoute
  '/login': typeof LoginRoute
  '/suche': typeof SucheRoute
  '/totes-kapital': typeof TotesKapitalRoute
  '/verkaufssuche': typeof VerkaufssucheRoute
  '/admin/api-keys': typeof AdminApiKeysRoute
  '/admin/archiv': typeof AdminArchivRoute
  '/admin/upload': typeof AdminUploadRoute
  '/admin/users': typeof AdminUsersRoute
  '/artikel/$id': typeof ArtikelIdRoute
  '/lieferant/$name': typeof LieferantNameRoute
  '/admin/users/import': typeof AdminUsersImportRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/controlling': typeof ControllingRoute
  '/login': typeof LoginRoute
  '/suche': typeof SucheRoute
  '/totes-kapital': typeof TotesKapitalRoute
  '/verkaufssuche': typeof VerkaufssucheRoute
  '/admin_/api-keys': typeof AdminApiKeysRoute
  '/admin_/archiv': typeof AdminArchivRoute
  '/admin_/upload': typeof AdminUploadRoute
  '/admin_/users': typeof AdminUsersRoute
  '/artikel/$id': typeof ArtikelIdRoute
  '/lieferant/$name': typeof LieferantNameRoute
  '/admin_/users_/import': typeof AdminUsersImportRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/controlling'
    | '/login'
    | '/suche'
    | '/totes-kapital'
    | '/verkaufssuche'
    | '/admin/api-keys'
    | '/admin/archiv'
    | '/admin/upload'
    | '/admin/users'
    | '/artikel/$id'
    | '/lieferant/$name'
    | '/admin/users/import'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/controlling'
    | '/login'
    | '/suche'
    | '/totes-kapital'
    | '/verkaufssuche'
    | '/admin/api-keys'
    | '/admin/archiv'
    | '/admin/upload'
    | '/admin/users'
    | '/artikel/$id'
    | '/lieferant/$name'
    | '/admin/users/import'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/controlling'
    | '/login'
    | '/suche'
    | '/totes-kapital'
    | '/verkaufssuche'
    | '/admin_/api-keys'
    | '/admin_/archiv'
    | '/admin_/upload'
    | '/admin_/users'
    | '/artikel/$id'
    | '/lieferant/$name'
    | '/admin_/users_/import'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  ControllingRoute: typeof ControllingRoute
  LoginRoute: typeof LoginRoute
  SucheRoute: typeof SucheRoute
  TotesKapitalRoute: typeof TotesKapitalRoute
  VerkaufssucheRoute: typeof VerkaufssucheRoute
  AdminApiKeysRoute: typeof AdminApiKeysRoute
  AdminArchivRoute: typeof AdminArchivRoute
  AdminUploadRoute: typeof AdminUploadRoute
  AdminUsersRoute: typeof AdminUsersRoute
  ArtikelIdRoute: typeof ArtikelIdRoute
  LieferantNameRoute: typeof LieferantNameRoute
  AdminUsersImportRoute: typeof AdminUsersImportRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/controlling': {
      id: '/controlling'
      path: '/controlling'
      fullPath: '/controlling'
      preLoaderRoute: typeof ControllingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suche': {
      id: '/suche'
      path: '/suche'
      fullPath: '/suche'
      preLoaderRoute: typeof SucheRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/totes-kapital': {
      id: '/totes-kapital'
      path: '/totes-kapital'
      fullPath: '/totes-kapital'
      preLoaderRoute: typeof TotesKapitalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verkaufssuche': {
      id: '/verkaufssuche'
      path: '/verkaufssuche'
      fullPath: '/verkaufssuche'
      preLoaderRoute: typeof VerkaufssucheRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin_/api-keys': {
      id: '/admin_/api-keys'
      path: '/admin/api-keys'
      fullPath: '/admin/api-keys'
      preLoaderRoute: typeof AdminApiKeysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin_/archiv': {
      id: '/admin_/archiv'
      path: '/admin/archiv'
      fullPath: '/admin/archiv'
      preLoaderRoute: typeof AdminArchivRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin_/upload': {
      id: '/admin_/upload'
      path: '/admin/upload'
      fullPath: '/admin/upload'
      preLoaderRoute: typeof AdminUploadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin_/users': {
      id: '/admin_/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/artikel/$id': {
      id: '/artikel/$id'
      path: '/artikel/$id'
      fullPath: '/artikel/$id'
      preLoaderRoute: typeof ArtikelIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lieferant/$name': {
      id: '/lieferant/$name'
      path: '/lieferant/$name'
      fullPath: '/lieferant/$name'
      preLoaderRoute: typeof LieferantNameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin_/users_/import': {
      id: '/admin_/users_/import'
      path: '/admin/users/import'
      fullPath: '/admin/users/import'
      preLoaderRoute: typeof AdminUsersImportRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  ControllingRoute: ControllingRoute,
  LoginRoute: LoginRoute,
  SucheRoute: SucheRoute,
  TotesKapitalRoute: TotesKapitalRoute,
  VerkaufssucheRoute: VerkaufssucheRoute,
  AdminApiKeysRoute: AdminApiKeysRoute,
  AdminArchivRoute: AdminArchivRoute,
  AdminUploadRoute: AdminUploadRoute,
  AdminUsersRoute: AdminUsersRoute,
  ArtikelIdRoute: ArtikelIdRoute,
  LieferantNameRoute: LieferantNameRoute,
  AdminUsersImportRoute: AdminUsersImportRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
